import getActions from "./actionsPopupUtils";

const crop_actions = (formName, isSubaccount) => {
  return getActions({ formName, isSubaccount, shared: true });
};

export default crop_actions;
